import React from 'react';

/**
 * @desc INAVI Maps 회원 탈퇴 시 정보 삭제 범위
 * @returns
 */
const WithDrawalTerms = () => {
  return (
    <div class="content">
      <ol start="1">
        <li>
          <strong>일정 기간(3개월) 보유 후 삭제 정보</strong>
        </li>
      </ol>
      <p>
        APP 개발 과정에서 사용된 APPKEY(AppKey) 등 연동 데이터 및 기존 이용
        서비스 정보
      </p>
      <p>회원 가입 시 입력한 개인 정보</p>
      <p>&nbsp;</p>
      <ol start="2">
        <li>
          <strong>유지 정보</strong>
        </li>
      </ol>
      <p>문의하기 게시글 및 댓글</p>
      <p>사업자 회원 가입 시 입력한 사업자 정보</p>
    </div>
  );
};

export default WithDrawalTerms;
